import { Phone } from "./Phone"

// components/PhoneMockups.js
export const PhoneMockups = () => {
    return (
        <div className="relative max-w-3xl mx-auto mb-16">
            <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-pink-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-green-200/30 rounded-full blur-3xl -translate-x-full -translate-y-1/2"></div>
            <div className="relative flex justify-center items-center gap-4">
                <Phone
                    type="artist"
                    rotation="-rotate-6"
                    translation="translate-x-8"
                    gradient="from-purple-500 to-pink-500"
                />
                <Phone
                    type="brand"
                    rotation="rotate-6"
                    translation="-translate-x-8"
                    gradient="from-blue-500 to-purple-500"
                />
            </div>
        </div>
    )
}

// components/PhoneTemplate.js
export const PhoneTemplate = ({ rotation, translation, gradient }) => {
    return (
        <div className={`w-[240px] transform ${rotation} ${translation}`}>
            <div className="bg-black rounded-[2rem] p-3">
                <div className={`bg-gradient-to-br ${gradient} rounded-[1.7rem] aspect-[9/19.5]`}></div>
            </div>
        </div>
    )
}